import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlRequestModel } from '@apps-common/types/portal/unit-control'

export const testUnitControl = async (model?: IUnitControlRequestModel): Promise<boolean> =>
  axios.post(`/my-monitoring/control/TestControl`, model).then((res) => res?.data?.result)

type Props = {
  model?: IUnitControlRequestModel
}

export const useMyMonitoringTestControl = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['useMyMonitoringTestControl'],
    mutationFn: ({ model }: Props) => testUnitControl(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Commands sent.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to send commands, please try again.')
      }
    },
    throwOnError: false
  })
